import { render, staticRenderFns } from "./indiaQrExtra.vue?vue&type=template&id=5abfc688"
import script from "./indiaQrExtra.vue?vue&type=script&lang=ts"
export * from "./indiaQrExtra.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports